import type { DataTableMode } from '@odo/shared-ui';

export const DEFAULT_TABLE_MODE: DataTableMode = 'infinite';

type ModeStorage = Pick<Storage, 'getItem' | 'setItem'>;

// Storage can be missing or throw (privacy modes, quota); either way the default applies.
export function readTableMode(storage: ModeStorage | undefined, key: string): DataTableMode {
    try {
        return storage?.getItem(key) === 'paged' ? 'paged' : DEFAULT_TABLE_MODE;
    } catch {
        return DEFAULT_TABLE_MODE;
    }
}

export function writeTableMode(
    storage: ModeStorage | undefined,
    key: string,
    mode: DataTableMode
): void {
    try {
        storage?.setItem(key, mode);
    } catch {
        // Best effort: the choice still applies for this visit.
    }
}
